import { Link } from "react-router-dom";

export function TermsPage() {
  return (
    <div className="center">
      <div className="card" style={{ maxWidth: 800, margin: "2rem auto" }}>
        <h1>Terms of Service</h1>
        <p className="muted">Last updated: 18 May 2026</p>

        <p>
          BT-1851 Cloud ("the Service") is operated by Anj Industries
          ("we", "us"). By creating an account or signing in, you agree
          to these Terms of Service.
        </p>

        <h2>1. Eligibility</h2>
        <p>
          You must be at least 18 years old and authorised to bind the
          organisation you represent. The Service is intended for
          operators of Anj Industries BT-1851 battery test equipment.
        </p>

        <h2>2. Account responsibilities</h2>
        <p>
          You are responsible for keeping your credentials confidential
          and for all activity that occurs under your account. Notify us
          immediately at <a href="mailto:support@ausforce.com.au">support@ausforce.com.au</a> if
          you suspect unauthorised access.
        </p>

        <h2>3. Acceptable use</h2>
        <p>
          You agree not to: (a) reverse-engineer, decompile, or attempt
          to extract source code from the Service; (b) interfere with or
          disrupt the integrity or performance of the Service; (c) use
          the Service to store or transmit unlawful content; or (d)
          attempt to gain unauthorised access to any part of the Service
          or related systems.
        </p>

        <h2>4. Your data</h2>
        <p>
          You retain ownership of test data, device records, and other
          content you upload through paired BT-1851 devices. We store
          and process that data solely to deliver the Service to you.
          See the{" "}
          <Link to="/privacy">Privacy Statement</Link> for details on
          collection, storage, and your rights.
        </p>

        <h2>5. Intellectual property</h2>
        <p>
          The Service software, documentation, and visual design are
          the intellectual property of Anj Industries or its licensors.
          These Terms grant you a non-exclusive, revocable, non-
          transferable right to use the Service for its intended purpose.
        </p>

        <h2>6. Suspension and termination</h2>
        <p>
          We may suspend or terminate your access if you breach these
          Terms or if required by law. You may close your account at any
          time from the Account page; doing so deletes your personal
          profile but does not automatically delete organisation-owned
          device records — contact your organisation administrator for
          that.
        </p>

        <h2>7. Disclaimer</h2>
        <p>
          The Service is provided "as is" and "as available". To the
          maximum extent permitted under Australian Consumer Law, we
          disclaim all implied warranties of merchantability, fitness
          for a particular purpose, and non-infringement. Nothing in
          these Terms excludes any guarantee, right, or remedy that
          cannot be lawfully excluded under Australian Consumer Law.
        </p>

        <h2>8. Limitation of liability</h2>
        <p>
          To the extent permitted by law, our total liability for any
          claim arising from or relating to the Service is limited to
          the fees you paid us for the Service in the twelve months
          before the claim arose. We are not liable for indirect,
          incidental, consequential, or special damages.
        </p>

        <h2>9. Changes to these Terms</h2>
        <p>
          We may update these Terms from time to time. Material changes
          will be notified through the Service or by email to the
          contact address on your account. Continued use after the
          effective date constitutes acceptance.
        </p>

        <h2>10. Governing law</h2>
        <p>
          These Terms are governed by the laws of New South Wales,
          Australia. Disputes are subject to the exclusive jurisdiction
          of the courts of New South Wales.
        </p>

        <h2>11. Contact</h2>
        <p>
          Anj Industries — <a href="mailto:support@ausforce.com.au">support@ausforce.com.au</a>
        </p>

        <p style={{ marginTop: "2rem" }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
